export default "__VITE_ASSET__$BcmsWR4__"